document.addEventListener("DOMContentLoaded", function () {
    const hotSheetContentContainerClass = 'hot-sheet-library-content-container';
    const hotSheetListContainerClass = 'hot-sheet-library-card-container';
    const hotSheetCardClass = 'hot-sheet-card';
    const inputSearchId = 'customSearch';
    const selectSupplierId = 'selectSupplier';
    const selectYearId = 'selectYear';
    const selectCountryId = 'selectCountry';

    let searchTimerId;
    const filterObject = {
        search: '',
        supplier: -1,
        year: -1,
        country: ''
    }

    function debounce(callback, delay = 1000) {
        return (...args) => {
            clearTimeout(searchTimerId);
            searchTimerId = setTimeout(() => {
                callback(...args);
            }, delay);
        };
    }

    const _removeAllHotSheets = function () {
        const _elements = document.querySelectorAll(`.${hotSheetListContainerClass} .${hotSheetCardClass}`);

        if (_elements) {
            for (let _element of _elements) {
                if (_element) {
                    _element.remove();
                }
            }
        }
    }

    const _updateCardStates = function (classToBeAdded) {
        const container = document.getElementsByClassName(hotSheetContentContainerClass)[0];

        container.classList.remove('show_error_msg');
        container.classList.remove('show_empty_msg');
        container.classList.remove('show_loading');

        if (classToBeAdded) {
            container.classList.add(classToBeAdded ?? '');
        }
    }

    const _getHotSheetList = function () {
        let _url = `/umbraco/surface/DTNAHotSheetLibraryApi/GetHotSheets?search=${filterObject.search}&supplier=${filterObject.supplier}&year=${filterObject.year}&country=${filterObject.country}`;
        _removeAllHotSheets();
        _updateCardStates('show_loading');

        const request = new XMLHttpRequest();
        request.open("GET", _url, true);

        request.addEventListener("load", function () {
            if (request.readyState === request.DONE && request.status === 200) {
                const container = document.getElementsByClassName(hotSheetListContainerClass)[0];
                container.insertAdjacentHTML('beforeend', request.responseText);
                _updateCardStates();
            } else {
                _updateCardStates('show_empty_msg');
            }
        });
        request.addEventListener("error", () => _updateCardStates('show_error_msg'));

        request.send();
    }

    const _setListeners = function () {
        const _inputSearch = document.getElementById(inputSearchId);
        if (_inputSearch) {
            _inputSearch.removeEventListener('keyup', () => { });
            _inputSearch.addEventListener('keyup', function (e) {
                filterObject.search = e.currentTarget.value;
                debounce(() => {
                    _getHotSheetList();
                }, 600)();
            });
        }

        const _selectSupplier = document.getElementById(selectSupplierId);
        if (_selectSupplier) {
            _selectSupplier.removeEventListener('change', () => { });
            _selectSupplier.addEventListener('change', function (e) {
                filterObject.supplier = e.currentTarget.value;
                _getHotSheetList();
            });
        }

        const _selectYear = document.getElementById(selectYearId);
        if (_selectYear) {
            _selectYear.removeEventListener('change', () => { });
            _selectYear.addEventListener('change', function (e) {
                filterObject.year = e.currentTarget.value;
                _getHotSheetList();
            });
        }

        // Ensure filterObject.country is initialized as an array
        if (!Array.isArray(filterObject.country)) {
            filterObject.country = [];
        }

        const _selectCountries = document.querySelectorAll(`input[type="checkbox"][id^="${selectCountryId}"]`); // Select all checkboxes

        _selectCountries.forEach(checkbox => {
            const handleChange = (e) => {

                const countryName = e.currentTarget.value; // Get the country name from the checkbox value

                if (countryName) { // Ensure countryName is defined

                    if (e.currentTarget.checked) {

                        // If checked, add the country name
                        if (!filterObject.country.includes(countryName)) {

                            filterObject.country.push(countryName);

                        }

                    } else {

                        // If unchecked, remove the country name
                        filterObject.country = filterObject.country.filter(country => country !== countryName);

                    }

                    _getHotSheetList(); // Call the function to update the list

                } else {

                    console.error("Checkbox value is not defined.");

                }

            };


            checkbox.addEventListener('change', handleChange);

        });
    
    }


    const _init = function () {
        if (window.location.href.includes('hot-sheet')) {
            _setListeners();
            _getHotSheetList();
        }
    }

    if (document.readyState == "complete") {
        _init();
    } else {
        window['addEventListener']("load", _init, 0);
    }
});
